export default __webpack_public_path__ + "static/media/job_portal_logo.ebdc1803.svg";